import { useDateFormatter, useTranslations } from "@/contexts/Translation";
import { H2, H3 } from "../Headers/Headings";
import { InfoItem } from "../Survey/InfoItem";
import { CardStats as CardStatsType, Domain } from "../../types";
import CopyValue from "../CopyValue/CopyValue";
import { getCardUrl } from "@/lib/getCardUrl";

const getAnonymousResponders = (stats: CardStatsType) => {
  if (!stats || !stats.domains) {
    return null;
  }
  const domains = stats.domains;
  const anonymousResponders = domains.find((d) => d.domain === "anonymous.com");
  if (!anonymousResponders) {
    return null;
  }
  return anonymousResponders.responders;
};

const CardStats = ({ card }: any) => {
  const stats = card.stats;
  const d = useDateFormatter();
  const t = useTranslations("card");
  const anonymousResponders = stats ? getAnonymousResponders(stats) : 0;

  return (
    <>
      <H2>{t("cardStatsHeading")}</H2>
      <p>
        <CopyValue variant='text' testId='card-link' value={getCardUrl(card.cardId)} />
      </p>
      <InfoItem label={t("noOfSurveys")} value={stats.noOfSurveys} />
      <InfoItem label={t("noOfResponders")} value={card.responders} />
      <InfoItem label={t("uniqueResponders")} value={stats.uniqueResponders} />
      <InfoItem label={t("anonymousResponders")} value={!anonymousResponders ? "-" : String(anonymousResponders)} />
      <InfoItem label={t("earliestResponse")} value={!stats.earliestResponse ? "-" : d(stats.earliestResponse)} />
      <InfoItem label={t("statsLatestResponse")} value={!stats.latestResponse ? "-" : d(stats.latestResponse)} />
      {card.exposeDomains !== false && (
        <>
          <H3>{t("responderDomains")}</H3>
          {stats?.domains?.map((domain: Domain) => (
            <InfoItem key={domain.domain} label={domain.domain === "anonymous.com" ? t("anonymousDomain") : domain.domain} value={`${domain.responders}`} />
          ))}
        </>
      )}
    </>
  );
};

export default CardStats;
